import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { BRAND, IMG } from "../lib/content";

export default function FinalCta() {
  return (
    <section
      data-testid="final-cta"
      className="relative py-28 md:py-40 overflow-hidden bg-[#0A0A0A]"
    >
      <img
        src={IMG.blackStaircase}
        alt=""
        className="absolute inset-0 w-full h-full object-cover opacity-35"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/85 via-[#0A0A0A]/85 to-[#0A0A0A]/95" />
      <div className="bg-grain absolute inset-0 pointer-events-none" />
      <div className="relative max-w-5xl mx-auto px-6 md:px-10 text-center">
        <span className="text-[11px] uppercase tracking-[0.3em] text-[#E8DAB8]">
          Restore · Polish · Protect
        </span>
        <h2 className="font-display-bold text-5xl md:text-6xl lg:text-7xl tracking-tight text-white mt-6">
          Restore the natural beauty
          <br />
          <span className="font-serif-italic font-light text-[#E8DAB8]">of your stone.</span>
        </h2>
        <p className="mt-8 text-white/75 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
          Free on-site inspection. Honest, fixed-price quotes. Sydney-wide service
          delivered by craftsmen with {BRAND.experienceYears}+ years' combined experience.
        </p>
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/contact"
            data-testid="cta-quote-btn"
            className="group inline-flex items-center gap-3 px-9 py-4 bg-[#C9A86A] text-black uppercase tracking-[0.22em] text-[11px] hover:bg-[#B8965A] transition-colors"
          >
            Get free quote
            <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
          </Link>
          <a
            href={BRAND.phoneHref}
            data-testid="cta-call-btn"
            className="inline-flex items-center gap-3 px-9 py-4 border border-white/30 text-white uppercase tracking-[0.22em] text-[11px] hover:bg-white/10 transition-colors"
          >
            <Phone className="w-4 h-4" /> Call {BRAND.phone}
          </a>
        </div>
      </div>
    </section>
  );
}
